export const DOCUMENT_ENTITY_NAME = 'Document';
export const DOCUMENT_INPUT_PORT_ENTITY_NAME = 'DocumentInputPort';
export const DOCUMENT_OUTPUT_PORT_ENTITY_NAME = 'DocumentOutputPort';
export const CONTENT_BOOK_ENTITY_NAME = 'ContentBook';
